import { WrongTenantError } from '../Login/wrongTenantError';

const errorName = (error: unknown): string | undefined => {
  if (error == null || typeof error !== 'object') {
    return undefined;
  }
  const { name, code, __type } = error as { name?: unknown; code?: unknown; __type?: unknown };
  const value = __type ?? code ?? name;
  return typeof value === 'string' ? value : undefined;
};

const errorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : typeof error === 'string' ? error : '';

/**
 * The message to show after a failed OTP sign-in. Every failure is treated as having used the code
 * up: the DefineAuthChallenge trigger (outthink-cognito-funcs) fails the whole auth flow after one
 * wrong answer, so Cognito discards the session and re-submitting - even the right code - only gets
 * "Invalid session for the user" (HRI2-18976). The way forward is always a new code.
 */
export const otpSignInErrorMessage = (error: unknown): string => {
  if (error instanceof WrongTenantError) {
    return error.message;
  }

  if (errorName(error) === 'NotAuthorizedException') {
    // Cognito reports a wrong answer and a dead session with the same name; only the message
    // tells them apart.
    if (/invalid session|session is expired/i.test(errorMessage(error))) {
      return 'This code has expired. Request a new code to sign in.';
    }
    return 'Incorrect code. Each code can only be tried once, so request a new code to try again.';
  }

  // A network failure or throttling may also have consumed the session, and there is no way to
  // tell from here, so ask for a new code rather than risk another silent dead end.
  return "We couldn't sign you in with that code. Request a new code and try again.";
};
